import { render, staticRenderFns } from "./DichiarazioneList.vue?vue&type=template&id=2aaf27ed&"
import script from "./DichiarazioneList.vue?vue&type=script&lang=js&"
export * from "./DichiarazioneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DichiarazioneList.vue"
export default component.exports